import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Grid
} from '@mui/material';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import InvoicePreview from './InvoicePreview';
import SubscriptionForm from './SubscriptionForm';


const SubscriptionSettings = () => {
  return (
    <Box p={2}>
      {/* Breadcrumb */}
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <Link
          underline="hover"
          color="inherit"
          href="/"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#1A1F36' }}
        >
          <ArrowBackIosIcon sx={{ fontSize: '16px', color: '#1760EC' }} /> Settings
        </Link>
      </Breadcrumbs>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, }}>
        <Box className="card-body  bg-base border rounded-3 overflow-hidden h-100" sx={{ display: 'flex', alignItems: 'center', width: '100%', padding: '14px 16px' }}>
          <Typography sx={{ fontSize: '19px', fontWeight: '700', color: '#1A1F36', fontFamily: 'Manrope' }}>Subscription Settings</Typography>
        </Box>
      </Box>

      <Box sx={{ marginTop: '12px' }}>
        <Grid container spacing={2}>
          <Grid size={{ xl: 7, lg: 6, md: 6, sm: 12, xs: 8 }}>
            <SubscriptionForm />
          </Grid>
          <Grid size={{ xl: 5, lg: 6, md: 6, sm: 12, xs: 8 }}>
            <InvoicePreview />
          </Grid>
        </Grid>
      </Box>

    </Box>
  );
};

export default SubscriptionSettings;
